module.exports = __webpack_public_path__ + "static/media/gallery.18.880c7cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/images/gallery.18.jpg
// module id = 616
// module chunks = 0